<script>
    import _          from 'lodash'
    import validate   from 'validate.js'
    import Item       from '../../shared/Item.svelte'
    import FieldError from '../../shared/FieldError.svelte'

    export let item
    export let active
    export let withHeader = true
    export let onUpdate = () => true
    export let onRemove = () => true

    const constraints = {
        name : { 
            presence : { allowEmpty: false, message: "campo obrigatório" } 
        },
        email : { 
            presence : { allowEmpty: false, message: "campo obrigatório" }, 
            email    : {                    message: "email inválido"    } 
        }
    }

    function validateItem(it) {
        return validate(it, constraints, { fullMessages: false }) || {}
    }

    function isDirty(item, copy) {
        return ! _.isEqual(item, copy)
    }
</script>

<Item debug={false} 
      bind:item 
      bind:active
      edit={item.type !== 'owner'}
      {isDirty} 
      {onUpdate} 
      {onRemove}
      {validateItem} 
      {withHeader}>
    <span slot="header">
        <span class="name">        {item.name}  </span>
        <span class="description"> {item.email} </span>
    </span>
    <div slot="primary" let:errors>
        <form class="ui big form">
            <div class="field"
                class:error={errors.name}>
                <label for="name">Nome</label>
                <input  id="name"
                        type="text"
                        autocomplete="false"
                        bind:value={item.name}>
                <FieldError style="label" property={errors['name']}/>
            </div>
            <div class="field"
                class:error={errors.email}>
                <label for="email">Email</label> 
                <div class="ui icon input">
                    <input  id="email" 
                            type="text" 
                            autocomplete="false"
                            bind:value={item.email}>
                </div>
                <FieldError style="label" property={errors['email']}/>
            </div>
        </form>
    </div>
</Item>
<style>
    .form {
        margin: 1em 0;
    }
</style>
